import { IDeliveryAddressSuggestion } from 'generated/graphql-gateway';
import { region } from 'utils/environment';
import { RegionToISOs } from 'utils/form/constants';
import { IPlaceData } from 'utils/geolocation';

const STREET_NUMBER_REGEX = /^(\d+[A-Za-z-]*)\s+(.*)$/;

function splitStreet(street: string): { streetNumber: string; route: string } {
  if (!street) {
    return { streetNumber: '', route: '' };
  }

  const match = street.match(STREET_NUMBER_REGEX);

  if (!match) {
    return { streetNumber: '', route: street };
  }

  return {
    streetNumber: match[1]?.trim() ?? '',
    route: match[2]?.trim() ?? '',
  };
}

export function deliverySuggestionToPlaceData(
  suggestion?: IDeliveryAddressSuggestion | null
): IPlaceData | undefined {
  if (!suggestion) {
    return undefined;
  }

  const lat = suggestion.location?.lat;
  const lng = suggestion.location?.lng;

  if (typeof lat !== 'number' || typeof lng !== 'number') {
    return undefined;
  }

  const { streetNumber, route } = splitStreet(suggestion.street?.trim() ?? '');

  return {
    coordinates: {
      lat,
      lng,
    },
    address: {
      addressLine1: suggestion.street?.trim() ?? '',
      addressLine2: suggestion.unit?.trim() ?? '',
      alias: '',
      city: suggestion.city?.trim() ?? '',
      country: RegionToISOs[region],
      defaultInstruction: '',
      route,
      state: suggestion.state?.trim() ?? '',
      streetNumber,
      zip: suggestion.zip_code?.trim() ?? '',
      shouldSave: false,
      phoneNumber: '',
    },
  };
}
